import { Outlet } from 'react-router'
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material'

import { generateTheme } from '../../providers/mui-theme-provider'
import useScrollToTop from '../../utils/hooks/useScrollToTop'
import ErrorBoundary from '../error-boundary'

interface IProps {
  useDarkBackground?: boolean
}

const RouteWrapper = (props: IProps) => {
  const { useDarkBackground = false } = props
  const lightTheme = createTheme(generateTheme('light'))
  const darkTheme = createTheme(generateTheme('dark'))
  useScrollToTop()

  return (
    <ErrorBoundary>
      <ThemeProvider theme={useDarkBackground ? darkTheme : lightTheme}>
        <CssBaseline />
        <Outlet />
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default RouteWrapper
